import { IconSearchAlt, mapper } from '@maia/icons';
import { InsuranceDto } from '@maia/shared';
import {
  ActionButton,
  CardFooter,
  CardHeader,
  FeaturedIcon,
  Typography,
  cardStyles,
} from '@maia/ui';
import { formatCurrency, formatDate } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type InsuranceCardProps = {
  insurance: InsuranceDto;
  onOpen: () => void;
};

export function InsuranceCard(props: InsuranceCardProps) {
  const { insurance, onOpen } = props;

  return (
    <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-12')}>
      <CardHeader
        title={insurance.title}
        icon={
          <FeaturedIcon variant="light-square" icon={mapper(insurance.icon)} />
        }
        actions={[
          <ActionButton icon={IconSearchAlt} size="small" onPress={onOpen} />,
        ]}
        status={insurance.status}
        alignIcon
      />
      <CardFooter
        className="mt-8"
        timestamp={{
          showIcon: true,
          date: formatDate(insurance.premiumDueDate),
        }}
      >
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale300"
        >
          {formatCurrency(insurance.price.premiumAfterTax)}
        </Typography>
      </CardFooter>
    </div>
  );
}
